export default __webpack_public_path__ + "static/media/songwriter_benefits_1.05dfceb1.svg";